import React from "react";
import Header from "../../components/Header/Header.js";
import Base from "../../components/Base/Base.js";
import "./style.scss";

function Home() {
  return (
    <>
      <div className="homepage">
        <Header />
        <Base />
      </div>
    </>
  );
}

export default Home;
